import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { activeListFilterClass } from '@/lib/listFilterUi';

type Props = {
  onClick: () => void;
  label: string;
};

/** Resets all list filters on the same toolbar row. */
export function ClearListFiltersButton({ onClick, label }: Props) {
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={activeListFilterClass(true, 'h-9 w-9 shrink-0 text-primary hover:bg-primary/10')}
      onClick={onClick}
      title={label}
      aria-label={label}
    >
      <X className="h-4 w-4" />
    </Button>
  );
}
